import React from 'react';
import PropTypes from 'prop-types';
import {
  ExtendedBox,
  ExtendedFlex,
  Heading,
  Body,
  NavLink,
  VisibilitySensor,
} from '../../../coreui';

import FadeIn from '../../../components/FadeIn';

const ExploreOpportunitiesSection1 = ({
  handleSensorChange,
  isVisible,
  linkButtonText,
}) => {
  return (
    <ExtendedBox
      boxSizing="border-box"
      width={[1, 1, 0.5, 0.5, 0.5]}
      px={['15%', '25%', '5%', '5%', '5%']}
      pt={[100, 100, 100, 160, 220]}
      pb={[0, 0, 100, 120, 180]}
    >
      <ExtendedFlex
        flexDirection="column"
        align="flex-end"
      >
        <ExtendedFlex
          maxWidth={['100%', '100%', 320, 400, 540]}
          flexDirection="column"
        >
          <FadeIn>
            <Heading
              type="H2"
              m={0}
              mb="1em"
              opacity={isVisible ? '1' : '0'}
            >
              Explore Opportunities Beyond Public-Market Equities and Bonds.
            </Heading>
          </FadeIn>
          <VisibilitySensor
            callback={handleSensorChange}
          />
          <FadeIn
            fadeInIndex={2}
          >
            <Body
              type="B1"
              mb={[0, 0, 80, 80, 100]}
              opacity={isVisible ? '1' : '0'}
            >
              Diversify with thoroughly vetted commercial real estate,
              potentially generating income and growing value.
            </Body>
          </FadeIn>
          <ExtendedBox
            display={['none', 'none', 'block']}
          >
            <FadeIn
              fadeInIndex={3}
            >
              <NavLink
                type="L1"
                to="/benefits-of-investing"
                opacity={isVisible ? '1' : '0'}
              >
                {linkButtonText}
              </NavLink>
            </FadeIn>
          </ExtendedBox>
        </ExtendedFlex>
      </ExtendedFlex>
    </ExtendedBox>
  );
};

ExploreOpportunitiesSection1.propTypes = {
  handleSensorChange: PropTypes.func,
  isVisible: PropTypes.bool,
  linkButtonText: PropTypes.string,
};

export default ExploreOpportunitiesSection1;
